import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatLegacyCheckboxChange as MatCheckboxChange } from '@angular/material/legacy-checkbox';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { MatLegacyRadioChange as MatRadioChange } from '@angular/material/legacy-radio';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, map, tap } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { Product } from '../../../products/interfaces';
import { ProductDataSource } from '../../../products/product-data-source';
import { ProductsService } from '../../../products/products.service';
import { SubTypeEnum } from '../../../shared/enums/enums';
import { TabKeyEnum } from '../../../shared/enums/tab-key-enum';
import { AuthService, AuthType, ESP_LOGIN_DATA } from '../../../shared/services/auth.service';

@Component({
  selector: 'xcdrs-custom-tab-value-dialog',
  templateUrl: './custom-tab-value-dialog.component.html',
  styleUrls: ['./custom-tab-value-dialog.component.scss']
})
export class CustomTabValueDialogComponent implements OnInit, OnDestroy {
  SubTypeEnum = SubTypeEnum;
  loading: boolean;
  dataSource: ProductDataSource;
  items: { id: string, name: string }[] = []
  selectedItems: { id: string, name: string }[] = []
  private _subs: SubSink = new SubSink();
  title: string;
  tabKeyEnum = TabKeyEnum
  constructor(
    private productsService: ProductsService,
    private authService: AuthService,
    private dialogRef: MatDialogRef<CustomTabValueDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      type: SubTypeEnum | TabKeyEnum
      items?: [],
      selectedItems: string,
      request: Observable<any>
    }
  ) {
    this.setTitle();
    if (this.data.type == SubTypeEnum.RequestCatalog || this.data.type == SubTypeEnum.REQUEST || this.data.type == SubTypeEnum.REQUESTS ||
      [TabKeyEnum.Requests, TabKeyEnum.EspSurveys, TabKeyEnum.EspRecords].includes(this.data.type as TabKeyEnum)) {
      this.loading = true;
      this.data.request.pipe(map(res => {
        return res.map(item => {
          return { id: item.id, name: item.name }
        })
      }),
        finalize(() => { this.loading = false; }),
        catchError((err: any) => {
          sessionStorage.removeItem(ESP_LOGIN_DATA);
          this.dialogRef.close();
          throw err;
        })).subscribe((res: any) => {
          this.items = res;
          console.log("🚀 ~ CustomTabValueDialogComponent ~ catchError ~ this.items:", this.items)
          this.loadSelectedItems();
          this.loading = false;
        })
    } else if (this.data.type == SubTypeEnum.TOPIC) {
      this.dataSource = new ProductDataSource(this.productsService)
      this._subs.sink = this.initTopics().subscribe()
      this._subs.sink = this.dataSource.loading$
        .subscribe(isLoading => {
          if (isLoading) {
            this.loading = true;
            // this.loadingService.loadingOn();
          } else {
            this.loading = false;
            // this.loadingService.loadingOff();
            this.mapProductsToItems();

          }
        });
    } else if (this.data.type == SubTypeEnum.DASHBOARD) {
      this._subs.sink = this.initDashboardItems();
    }

    else if (this.data.type = TabKeyEnum.SocialMedia) {
      this.items = this.data.items;
      this.loadSelectedItems();

    }
  }
  setTitle() {
    if (this.data.type == SubTypeEnum.RequestCatalog ||
      [TabKeyEnum.Requests, TabKeyEnum.EspSurveys, TabKeyEnum.EspRecords].includes(this.data?.type as TabKeyEnum)) {
      this.title = 'CustomTabsPage.SelectRequests';
    }
    else if (this.data.type == SubTypeEnum.REQUEST) {
      this.title = 'CustomTabsPage.SelectRequest';
    }
    else if (this.data.type == SubTypeEnum.DASHBOARD) {
      this.title = 'CustomTabsPage.SelectDashboard';
    }
    else if (this.data.type == SubTypeEnum.TOPIC) {
      this.title = 'CustomTabsPage.SelectTopic'

    } else if (this.data.type == TabKeyEnum.SocialMedia) {
      this.title = 'CustomTabsPage.SelectGroup'

    }
  }
  loadSelectedItems() {
    if (this.data.selectedItems && this.items) {
      this.selectedItems = this.data.selectedItems.split(',').map(id => this.items.find(item => item.id == id)).filter(s => !!s)
    }
  }

  ngOnInit(): void {

  }

  initTopics(): Observable<any> {
    return this.authService.getAddonsAuth(this.authService.idenediGroupId).pipe(
      map(addons => {
        return addons.find(
          addon => addon.Type === AuthType.Technadopt)
      }),
      tap(addon => {
        if (addon?.OrganziationId) {
          this.dataSource.loadProducts(
            {
              limit: 20,
              start: 0,
              activeOnly: true,
              isAdminCall: false,
              organziationId: addon?.OrganziationId
            })
        } else {
          this.dataSource.loadProducts(
            { limit: 20, start: 0, activeOnly: true, isAdminCall: false })
        }
        this.mapProductsToItems();
      }))
  }

  initDashboardItems() {
    return this.authService.getAddonsAuth(this.authService.idenediGroupId).pipe(
      map(addons => {
        return addons.find(
          addon => addon.Type.toLowerCase() === AuthType.PowerBi.toLowerCase())
      })).subscribe(addon => {
        let pbi = [];
        pbi = [...addon?.PublicProperties.powerBiData.map(d => { return { id: d.id, name: d.displayName } }),
        ...addon?.PublicProperties.powerBiReportData.map(dr => { return { id: dr.id, name: dr.displayName } })];
        this.items = pbi;
        this.loadSelectedItems();

      })
  }

  mapProductsToItems() {
    this.items = this.dataSource?.data?.map((d: Product) => { return { id: d.TopicId, name: d.TopicName } }) ?? [];
    this.loadSelectedItems();
  }
  onScroll() {
    if (this.data.type == SubTypeEnum.TOPIC) {
      this.dataSource?.loadMore();
    }
  }

  onSearchInputChange(event: any) {
    this.loading = true;
    this.data.request.pipe(map(res => {
      return res.map(item => {
        return { id: item.id, name: item.name }
      })
    }),
      finalize(() => { this.loading = false; }),
      catchError((err: any) => {
        sessionStorage.removeItem(ESP_LOGIN_DATA);
        this.dialogRef.close();
        throw err;
      })).subscribe((res: any) => {
        this.items = res.filter(i => i.name.toLowerCase().includes(event.toLowerCase()));
        this.loadSelectedItems();
        this.loading = false;
      })
  }

  isSelected(itemId): boolean {
    return this.selectedItems.some(i => i.id == itemId);
  }
  onCheckboxChanged(event: MatCheckboxChange) {
    const itemId = event.source.value;
    const item = this.items.find(i => i.id == itemId);
    if (event.checked) {
      this.selectedItems.push(item);

    } else {
      this.selectedItems = this.selectedItems.filter(i => i.id !== itemId);
    }

  }
  onRadioBtnChange(event: MatRadioChange) {
    const itemId = event.source.value;
    const item = this.items.find(i => i.id == itemId);
    this.selectedItems = [];
    this.selectedItems.push(item);
  }
  closeDialog() {
    this.dialogRef.close(this.selectedItems);
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
